import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import toastMessages from "../../helpers/toastMessage";
import DuplicatePatientPayload from "../../../models/API/requestModels/duplicatePatientPayload.model";

function useDuplicatePatient() {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["duplicatePatient"],
    mutationFn: (payload: DuplicatePatientPayload) =>
      axiosInstance
        .post("/v1/patients/duplicate", payload, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ?? error?.message ?? "Failed to duplicate patient";
      toastMessages.error(errorMessage);
    },
    onSuccess: (_data, variables) => {
      toastMessages.success("Patient duplicated to organization successfully.");
      queryClient.invalidateQueries({
        queryKey: ["patientsList", { organizationId: variables.organizationId }],
      });
      queryClient.invalidateQueries({ queryKey: ["patientDetail"] });
    },
  });
}

export default useDuplicatePatient;
